/** Bucket present-date strings (yyyy-mm-dd) within a calendar month. */

function dayOfMonthFromYmd(s) {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(String(s || "").trim());
  if (!m) return null;
  return Number(m[3]);
}

/** Weeks starting on the 1st: W1 = days 1–7, W2 = 8–14, … */
export function bucketPresentDatesByCalendarWeeks(presentDates) {
  const counts = [0, 0, 0, 0, 0];
  for (const s of presentDates || []) {
    const dom = dayOfMonthFromYmd(s);
    if (dom == null || dom < 1 || dom > 31) continue;
    const idx = Math.floor((dom - 1) / 7);
    if (idx >= 0 && idx < 5) counts[idx] += 1;
  }
  return {
    W1: counts[0],
    W2: counts[1],
    W3: counts[2],
    W4: counts[3],
    W5: counts[4],
  };
}

export function bucketPresentDatesByFortnight(presentDates) {
  let f1 = 0;
  let f2 = 0;
  for (const s of presentDates || []) {
    const dom = dayOfMonthFromYmd(s);
    if (dom == null) continue;
    if (dom <= 15) f1 += 1;
    else f2 += 1;
  }
  return { F1_1_to_15: f1, F2_16_to_end: f2 };
}

/**
 * Sum fractional day-units per calendar week (same week boundaries as {@link bucketPresentDatesByCalendarWeeks}).
 * @param {Record<string, number>} unitsByYmd — yyyy-mm-dd → units (e.g. 0.5 for half day)
 */
export function bucketDayUnitsByCalendarWeeks(unitsByYmd) {
  const counts = [0, 0, 0, 0, 0];
  if (!unitsByYmd || typeof unitsByYmd !== "object") {
    return { W1: 0, W2: 0, W3: 0, W4: 0, W5: 0 };
  }
  for (const [s, rawU] of Object.entries(unitsByYmd)) {
    const dom = dayOfMonthFromYmd(s);
    if (dom == null || dom < 1 || dom > 31) continue;
    const idx = Math.floor((dom - 1) / 7);
    if (idx < 0 || idx >= 5) continue;
    const u = Number(rawU);
    if (!Number.isFinite(u) || u <= 0) continue;
    counts[idx] += u;
  }
  return {
    W1: counts[0],
    W2: counts[1],
    W3: counts[2],
    W4: counts[3],
    W5: counts[4],
  };
}

/** Sum day-units for fortnights 1–15 vs 16–end. */
export function bucketDayUnitsByFortnight(unitsByYmd) {
  let f1 = 0;
  let f2 = 0;
  if (!unitsByYmd || typeof unitsByYmd !== "object") {
    return { F1_1_to_15: 0, F2_16_to_end: 0 };
  }
  for (const [s, rawU] of Object.entries(unitsByYmd)) {
    const dom = dayOfMonthFromYmd(s);
    if (dom == null) continue;
    const u = Number(rawU);
    if (!Number.isFinite(u) || u <= 0) continue;
    if (dom <= 15) f1 += u;
    else f2 += u;
  }
  return { F1_1_to_15: f1, F2_16_to_end: f2 };
}
